/* eslint-disable quote-props */
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ButtonPosition, ButtonSize, ButtonStyle, FileName, Icons } from '../../services/shared/shared-enums';
import { SharedUtilService } from '../../services/shared/shared-util.service';
import { ErrorMessageHeading, ErrorMessageSubHeading } from 'projects/kinetic-angular/src/lib/components';
import { ApiResponse } from '../../definitions/api-response.interface';
import { KngUploadFileFactory, KngUploadFileState } from 'projects/kinetic-angular/src/lib/components/upload-file';
import { ApiService } from '../../services/api/api.service';
import { InviteUserState, UploadFile, UserData } from './definitions';
import { InviteUserConfig } from '../invite-users/invite-users.config';
import { SharedService } from '../../services/shared/shared.service';
import { InviteUsersFactory } from './invite-users.factory';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';

@Injectable({
	providedIn: 'root'
})
export class InviteUsersService
{
	state$: BehaviorSubject<InviteUserState> = new BehaviorSubject<InviteUserState>(InviteUsersFactory.build());
	uploadFileState: KngUploadFileState = KngUploadFileFactory.build();

	getFileUploadStatus = new BehaviorSubject<string>('');
	castFileUploadStatus = this.getFileUploadStatus.asObservable();

	isUploadSuccess: boolean = false;
	downloadTemplateError: boolean = false;
	isRaymond = this.sharedService.isRaymond || false;
	failedCount = 0;
	totalCount = 0;
	displayFlag: boolean = true;
	submitButtonState = this.sharedUtilService.getButtonState(this.isRaymond?ButtonSize.large:ButtonSize.medium, ButtonStyle.primary, '', false, { altText: '', iconPath: '' }, ButtonPosition.right);
	sendInviteButtonState = this.sharedUtilService.getButtonState(ButtonSize.medium, ButtonStyle.primary, '', false, { altText: '', iconPath: '' }, ButtonPosition.right);
	cancelButtonState = this.sharedUtilService.getButtonState(ButtonSize.medium, ButtonStyle.secondary, '', false, { altText: '', iconPath: '' }, ButtonPosition.left);
	downloadButtonState = this.sharedUtilService.getButtonState(ButtonSize.medium, this.isRaymond ? ButtonStyle.tertiary : ButtonStyle.secondary, '', false, { altText: '', iconPath: this.isRaymond ? Icons.downloadButtonIconRaymond : '' }, this.isRaymond ? ButtonPosition.left : ButtonPosition.right);
	linkButtonState= this.sharedUtilService.getButtonState(ButtonSize.medium, ButtonStyle.link, '', false, { altText: '', iconPath: '' }, ButtonPosition.left);
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	submitResponse: any;
	constructor(public apiService: ApiService, private readonly toaster: ToastrService, private readonly sharedUtilService: SharedUtilService, public sharedService: SharedService) { }

	get state(): InviteUserState
	{
		return this.state$.value;
	}
	public updateState(value: InviteUserState): void
	{
		this.state$.next(value);
	}
	public getInviteUsersLabelState(isBulkUser:boolean = false): void
	{
		this.apiService.getInviteUsersAemLabels().subscribe((res) =>
		{
			if (res)
			{
				this.state.pageHeading = res.pageHeading;
				this.state.bulkInvite = res.bulkInvite;
				this.state.description = res.description;
				this.state.descriptionItems = res?.descriptionItems || [];
				this.state.downloadReport = res.downloadReport;
				this.submitButtonState.label =this.sharedService.nullValueHandler(res.submit.downloadButton);
				this.sendInviteButtonState.label =this.sharedService.nullValueHandler(this.isRaymond ? res.addUserBulkUploadBtn : res.sendInvite.downloadButton);
				this.cancelButtonState.label =this.sharedService.nullValueHandler(res.cancel);
				this.downloadButtonState.label =this.sharedService.nullValueHandler(res.download.downloadButton);
				this.mapUploadFilePopup(res.uploadFile, this.uploadFileState);
				this.state.uploadFile.uploadButtons.chooseFile=res.uploadFile.uploadButtons.chooseFile;
				this.state.uploadFile.success.bulkMessage=res.uploadFile.success.bulkMessage;
				this.state.uploadFile.success.inviteSuccess=res.uploadFile.success.inviteSuccess;
				this.state.externalLink.label = this.sharedService.nullValueHandler(res.externalLink.label);
				this.state.externalLink.url = !isBulkUser ? this.sharedService.nullValueHandler(res.externalLink.url) : this.sharedService.nullValueHandler(res.externalLink.userUrl ?? '');
			}
		});
	}
	getFileStatus(newUser: string)
	{
		this.getFileUploadStatus.next(newUser);
		this.uploadFileState.fileUploadLoader = false;
	}
	checkServerValidationUploadFile(item: File, isBulkUsers: boolean)
	{
		this.uploadFileState.isLoading = true;
		this.downloadButtonState.disabled = true;
		const ele = document.getElementById('kng-modal-close');
		if (ele)
			ele.setAttribute('disabled', 'true');
		this.apiService.getInviteUserSubmit(item, isBulkUsers).subscribe({
			next: (res: ApiResponse) =>
			{
				if (res?.data)
				{
					this.uploadFileState.isLoading = false;
					this.isUploadSuccess = true;
					this.uploadFileState.isError = false;
					this.uploadFileState.isSuccessClient = true;
					this.uploadFileState.isSuccessServer = true;
					if (ele)
						ele.removeAttribute('disabled');
					this.downloadButtonState.disabled = false;
				}
			},
			error: (error: HttpErrorResponse): void =>
			{
				this.handleUploadLocationError(ele, error);
			},
			complete: () =>
			{
				setTimeout(() =>
				{
					this.uploadFileState.isLoading = false;
					this.isUploadSuccess = true;
				}, 1000);
			}
		});
	}
	handleUploadLocationError(ele: HTMLElement | null, error: HttpErrorResponse)
	{
		this.uploadFileState.isLoading = false;
		this.isUploadSuccess = false;
		this.uploadFileState.isError = true;
		this.uploadFileState.isSuccessClient = true;
		this.uploadFileState.isSuccessServer = false;
		if (ele)
			ele.removeAttribute('disabled');
		this.downloadButtonState.disabled = false;
		if (error.error.statusCode === 400)
		{
			this.uploadFileState.isSuccessClient = false;
			this.uploadFileState.errorHeading = ErrorMessageHeading.uploadFailed;
			this.uploadFileState.errorSubHeading = ErrorMessageSubHeading.templateMismatch;
		}
		else if (error.error.statusCode === 403 || 500)
		{
			this.uploadFileState.errorHeading = ErrorMessageHeading.uploadFailed;
			this.uploadFileState.errorSubHeading = ErrorMessageSubHeading.apiError;
		}
		else
		{
			this.uploadFileState.errorHeading = ErrorMessageHeading.uploadFailed;
			this.uploadFileState.errorSubHeading = error.error.message;
		}
	}
	getInviteUserLocationDownload(bulkUser: boolean)
	{
		this.downloadButtonState.disabled = true;
		this.apiService.getInviteUserLocationDownload(bulkUser).subscribe({
			next: (res) =>
			{
				this.sharedService.downloadExcel(FileName.inviteUserTemplate, res);
				this.downloadButtonState.disabled = false;
				this.downloadTemplateError = false;
			},
			error: (error: HttpErrorResponse) =>
			{
				this.downloadTemplateError = true;
				return error;
			}
		});
	}
	getInviteUserSubmitButton(item: File, isBulkUsers: boolean)
	{
		this.submitButtonState.disabled = true;
		this.sendInviteButtonState.disabled = true;
		this.uploadFileState.fileUploadLoader = true;
		this.state.responseMessage = '';
		this.state.messageTitle = '';
		this.state.messageDescription = '';
		this.state.link.downloadButton = '';
		this.apiService.getInviteUserSubmit(item, isBulkUsers).subscribe({
			// eslint-disable-next-line complexity
			next: (res : ApiResponse) =>
			{
				this.submitResponse= res.data;
				if(isBulkUsers){ this.submitResponse.data = res.data; }
				this.state.responseMessage = res.message;
				this.displayFlag = false;
				this.totalCount = this.submitResponse.data.length;
				this.failedCount = 0;
				const successCount:number = this.findCountDetails(this.submitResponse.data, isBulkUsers);
				if(this.totalCount > 0 && res.statusCode === 206)
				{
					this.state.link.downloadButton = InviteUserConfig.messages.downloadReport;
					this.state.messageDescription = this.isRaymond
						? InviteUserConfig.messages.partialSuccessDescriptionRaymond(successCount, this.totalCount, this.failedCount)
						: InviteUserConfig.messages.partialSuccessDescription(successCount, this.totalCount, this.failedCount);
					this.state.messageTitle = InviteUserConfig.messages.partialSuccess;
					this.toaster.warning(InviteUserConfig.messages.toasterPartialMsg, '', {
						timeOut: 3000
					});
				}
				if(!isBulkUsers && this.totalCount > 0 && res.statusCode === 407)
				{
					this.state.link.downloadButton = InviteUserConfig.messages.downloadReport;
					this.state.messageDescription = this.isRaymond
						? InviteUserConfig.messages.partialSuccessDescriptionRaymond(successCount, this.totalCount, this.failedCount)
						: InviteUserConfig.messages.partialSuccessDescription(successCount, this.totalCount, this.failedCount);
					this.state.messageTitle = InviteUserConfig.messages.partialSuccess;
					this.toaster.warning(this.isRaymond ? InviteUserConfig.messages.toasterPartialMsgRaymond : InviteUserConfig.messages.toasterPartialMsg, '', {
						timeOut: 3000
					});
				}
				else if(isBulkUsers && this.totalCount > 0 && res.statusCode === 200)
				{
					this.state.link.downloadButton = InviteUserConfig.messages.downloadReport;
					this.state.messageDescription = this.isRaymond
						? InviteUserConfig.messages.completeSuccessDescriptionRaymond(successCount)
						: InviteUserConfig.messages.completeSuccessDescription(successCount);
					this.state.messageTitle = InviteUserConfig.messages.completeSuccess;
					this.toaster.success(InviteUserConfig.messages.toasterSuccessMsg, '', {
						timeOut: 3000
					});
				}
				else if(!isBulkUsers && this.totalCount > 0 && res.statusCode === 200)
				{
					this.state.link.downloadButton = InviteUserConfig.messages.downloadReport;
					this.state.messageDescription = this.isRaymond
						? InviteUserConfig.messages.completeSuccessDescriptionTMHCorpRaymond(successCount)
						: InviteUserConfig.messages.completeSuccessDescriptionTMHCorp(successCount);
					this.state.messageTitle = InviteUserConfig.messages.completeSuccess;
					this.toaster.success(InviteUserConfig.messages.toasterSuccessMsg, '', {
						timeOut: 3000
					});
				}
				else if(!isBulkUsers)
				{
					this.state.link.downloadButton = InviteUserConfig.messages.downloadReport;
					this.state.messageDescription = InviteUserConfig.messages.TMHCorpNote;
					this.state.messageTitle = InviteUserConfig.messages.TMHCorpFailure;
					this.toaster.error(this.isRaymond ? InviteUserConfig.messages.toasterFailMsgRaymond : InviteUserConfig.messages.toasterFailMsg, '', {
						timeOut: 3000
					});
					this.uploadFileState.isLoading = false;
				}
				else if(res.statusCode === 207)
				{
					this.state.link.downloadButton = InviteUserConfig.messages.downloadReport;
					this.state.messageDescription = InviteUserConfig.messages.failureDescription;
					this.state.messageTitle = InviteUserConfig.messages.failure;
					this.toaster.error(this.isRaymond ? InviteUserConfig.messages.toasterFailMsgRaymond : InviteUserConfig.messages.toasterFailMsg, '', {
						timeOut: 3000
					});
					this.uploadFileState.isLoading = false;
				}
				this.getFileStatus(this.state.responseMessage);
			},
			error: (error: HttpErrorResponse) =>
			{
				this.downloadTemplateError = true;
				this.toaster.error(error.error.message, '', {
					timeOut: 3000
				});
				this.uploadFileState.isLoading = false;
				this.getFileStatus(error.error.message);
			}
		});
	}
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	findCountDetails(response: any, isBulkUsers: boolean)
	{
		for(let i = 0; i< response.length; i++)
		{
			if(!response[i].success && !isBulkUsers)
			{
				this.failedCount += 1;
			}
			else if(!response[i].isValid && isBulkUsers)
			{
				this.failedCount += 1;
			}
		}
		return (response.length - this.failedCount);
	}
	mapUploadFilePopup(data: UploadFile, uploadFileState: KngUploadFileState)
	{
		uploadFileState.dragDropSection = data.dragDropLabel;
		uploadFileState.or = data.orLabel;
		uploadFileState.uploadButtons.chooseFile= data.uploadButtons.chooseFile;
		uploadFileState.errorImage.altText = data.errorIcon.altText;
		uploadFileState.successImage.altText = data.successIcon.altText;
		uploadFileState.dragDropImage.altText = data.onLoadIcon.altText;
		uploadFileState.errorImage.iconPath = Icons.actionRed;
		uploadFileState.successImage.iconPath = Icons.checkGreen;
		uploadFileState.dragDropImage.iconPath = this.isRaymond ? Icons.dragDropIconRaymond : Icons.dragDropIcon;
		uploadFileState.fileUploadProgressText = data.progressLabel;
	}

	linkXLXSDownload(bulkUser: boolean)
	{
		let processedData = this.submitResponse.data ;
		if(bulkUser)
		{
			processedData = this.submitResponse.data.map((item: UserData) => ({
				...item,
				errors: item.errors.join('; '),
				locationID: item.locationID?.join('; ')
			  }));
		}
		else
		{
			 processedData = this.submitResponse.data.map((item: UserData) => ({
				...item,
				errors: item.errors.join('; '),
				roles: item.roles.join('; '),
				portalApprovedCustomerID: item.portalApprovedCustomerID.join('; '),
				lastLogin: JSON.stringify(new Date(item.lastLogin).toLocaleString()),
				portalApproveUserDate: JSON.stringify(new Date(item.portalApproveUserDate).toLocaleString()),
				tcDate: JSON.stringify(new Date(item?.tcDate as number).toLocaleString()),
				privacyDate: JSON.stringify(new Date(item?.privacyDate as number).toLocaleString())
			  }));
		}

		this.sharedService.downloadTableData(FileName.inviteUserTemplate, processedData, bulkUser ? 'bulk' : 'individual');
	  }

}
